module.exports = __webpack_public_path__ + "img/list_Character_sq_13.d52c6357.jpeg";